export const HOME_ROUTE = ["/", "/about-us"];
